import { Box } from '@chakra-ui/react';
import { Formik, Form, FieldArray } from 'formik';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { FormikOnChangeObserver } from '@/components/formBuilder/components';
import { ScoreCardContainer } from './ScoreCardContainer';
import { Feedback } from './Feedback';
import { OverallEvaluation } from './OverallEvaluation';
import { scoreCardValidationSchema } from '@/components/score-card-builder/validationSchema';
interface ScoreCardBuilderProps {
  formRef: React.RefObject<any>;
  initialValues?: { scoreCards: any[] };
  onSubmit?: (_values: any) => void;
  observFunc?: (_values: any) => void;
}

export const ScoreCardBuilder = ({
  formRef,
  initialValues = { scoreCards: [] },
  onSubmit = () => {},
  observFunc = () => {},
}: ScoreCardBuilderProps) => {
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const { source, destination } = result;
    const scoreCardsArr = Array.from(formRef?.current?.values?.scoreCards);
    const [removed] = scoreCardsArr.splice(source.index, 1);
    scoreCardsArr.splice(destination.index, 0, removed);
    const currentValues = formRef?.current?.values || {};

    formRef?.current?.setValues({
      ...currentValues,
      scoreCards: scoreCardsArr,
    });
  };

  return (
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      validationSchema={scoreCardValidationSchema}
      onSubmit={onSubmit}
      validateOnBlur={true}
      validateOnChange={false}
    >
      {(formik) => (
        <Form>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="score-card-droppable">
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{
                    flex: 1,
                    gap: '6px',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <FieldArray
                    name="scoreCards"
                    render={(arrayHelpers) =>
                      formik?.values?.scoreCards?.map((item, index) => (
                        <ScoreCardContainer
                          key={item.id}
                          item={item}
                          formik={formik}
                          index={index}
                          arrayHelpers={arrayHelpers}
                        />
                      ))
                    }
                  />
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <FormikOnChangeObserver onChange={observFunc} delay={0} />
          <Box mt="5px">
            <Feedback />
          </Box>
          <OverallEvaluation />
        </Form>
      )}
    </Formik>
  );
};
